/**
 * useToast Hook
 *
 * Convenient hook for showing toast notifications from any component.
 * Re-exports the toast context for easy access.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const toast = useToast();
 *
 *   const handleSuccess = () => {
 *     toast.success('Operation completed!');
 *   };
 *
 *   const handleError = () => {
 *     toast.error('Something went wrong', {
 *       message: 'Please try again later',
 *       duration: 5000,
 *     });
 *   };
 *
 *   const handleLoading = async () => {
 *     const toastId = toast.loading('Processing...');
 *
 *     try {
 *       await someAsyncOperation();
 *       toast.update(toastId, {
 *         type: ToastType.SUCCESS,
 *         title: 'Success!',
 *         duration: 3000,
 *       });
 *     } catch (error) {
 *       toast.update(toastId, {
 *         type: ToastType.ERROR,
 *         title: 'Failed',
 *         duration: 5000,
 *       });
 *     }
 *   };
 *
 *   return (
 *     <div>
 *       <button onClick={handleSuccess}>Success</button>
 *       <button onClick={handleError}>Error</button>
 *       <button onClick={handleLoading}>Loading</button>
 *     </div>
 *   );
 * }
 * ```
 */

import { useToastContext } from '@/components/core/Toast/ToastContext';

export const useToast = useToastContext;
